import client from './client';

export const pagesApi = {
  list: (univers) => client.get(`/pages${univers ? `?univers=${univers}` : ''}`, { auth: false }),
  getBySlug: (slug) => client.get(`/pages/${slug}`, { auth: false }),

  // Back Office
  adminList: () => client.get('/admin/pages'),
  adminGet: (id) => client.get(`/admin/pages/${id}`),
  create: (data) => client.post('/admin/pages', data),
  update: (id, data) => client.put(`/admin/pages/${id}`, data),
  remove: (id) => client.delete(`/admin/pages/${id}`),
};
